const Colors = {
  headerColor: '#212121',
  primaryColor: '#424242',
  accentColor: '#E2E2E2',
  white: '#FFFFFF',
  lightGray: '#E8E8E8',
  mediumLightGray: '#C8C8C8',
  gray: '#AAA',
  waitingGray: '#AAA',
  textColor: '#212121',
  hover: '#ba103d',
  transparentFormColor: '#FFFFFF66',
  loginPrimaryColor: '#222222',
  loginLigthenPrimaryColor: '#676767',
  loginDarkenPrimaryColor: '#111111',
  titleColor: '#424242',
  green: '#61BA79',
  approvedGreen: '#61BA79',
  red: '#EA4335',
  pastelRed: '#DD6B64',
  reprovedRed: '#FF5454',
  compliancePurple: '#B444EC',
  rhBlue: '#3498db',
  prussianBlue: '#003153',
  yellow: '#ED9C00',
  errorYellow: '#EB8C00',
  googleYellow: "#FBBC05",
  orange: '#ED6704',
  blue: '#6494E4',
  darkBlue: '#5284D2',
  blueVariante:'#8C9FE1',
  ongoing:'#245178',
}

export const chartColors = 
  [
    ["#B1B1B1", "#6799EA", "#C875F3"],
    ['#B1B1B1', Colors.googleYellow, Colors.green, Colors.red],
    ['#B1B1B1', Colors.googleYellow, Colors.green, Colors.red],
  ]

export default Colors
